/**
 * 법정 서식 인쇄
 * ---------------------------------------------------------------------------
 * 서버가 만든 HTML 을 새 창에 넣고 인쇄 대화상자를 띄운다.
 *
 * 왜 링크로 열지 않는가
 *   `window.open('/api/prints/...')` 로 열면 인증 헤더를 붙일 수 없다.
 *   토큰을 주소에 담으면 브라우저 기록·프록시 로그에 남는다. HTML 을 받아
 *   직접 써 넣으면 그런 일이 없다.
 *
 * 창을 미리 여는 이유
 *   요청이 끝난 뒤에 `window.open` 을 부르면 사용자 클릭과 떨어져 있어
 *   팝업 차단에 걸린다. 클릭 직후에 빈 창을 먼저 열고 내용을 나중에 넣는다.
 */

import { api, errorMessage } from './api';

export interface PrintTarget {
  dailyLogIds: string[];
  selfMeasurementId?: string | null;
}

export async function printDailyLogs(target: PrintTarget): Promise<string | null> {
  if (target.dailyLogIds.length === 0) return '인쇄할 일지를 선택해 주세요.';

  const win = window.open('', '_blank');
  if (!win) return '팝업이 차단되었습니다. 이 사이트의 팝업을 허용해 주세요.';

  win.document.write('<!doctype html><meta charset="utf-8"><title>인쇄 준비 중…</title>');

  try {
    const res = await api.post<{ html: string }>('/prints/daily-logs', {
      dailyLogIds: target.dailyLogIds,
      selfMeasurementId: target.selfMeasurementId ?? null,
    });

    win.document.open();
    win.document.write(res.data.html);
    win.document.close();
    return null;
  } catch (err) {
    win.close();
    return errorMessage(err, '인쇄 서식을 만들지 못했습니다.');
  }
}
